<div class="min-h-screen relative mb-40">
  @if (results.hasError() || invalidInputs()) {
    <div class="flex flex-col items-center justify-start mt-32">
      <div class="flex flex-col md:flex-row gap-4 items-center">
        <img src="assets/images/no-results.svg" class="w-fit" alt="Kein Ergebnis" />
        <div>
          <div class="font-grotesk-h5">Ooops, keine Ergebnisse?</div>
          <div class="mt-6">
            Wir konnten leider keine Ergebnisse zu Deinen Vorgaben finden. <br />Gehe zurück und
            passe die berechnungsrelevanten Daten an.
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="flex flex-col md:flex-row gap-x-8 min-h-screen relative">
      <div class="hidden lg:grid gap-y-8 w-[312px] shrink-0 content-start">
        <div class="text-xl font-bold">Filtern</div>
        <ng-container *ngTemplateOutlet="filterTemplate()" />
      </div>

      <div class="flex-1">
        <div class="hidden md:block text-xl font-bold mb-8">Tarife</div>
        <div class="mb-8 flex justify-between md:hidden">
          <div class="text-xl font-bold">Tarife</div>
          <div class="font-bold">{{ results.currentNumberOfErgebnisse() }} Ergebnisse</div>
        </div>
        <ui-results-sort
          [selected]="selectedSort()"
          [hasRatings]="hasRatings()"
          [currentErgebnisse]="results.currentNumberOfErgebnisse()"
          [expectedErgebnisse]="expectedErgebnisse()"
          (sortChanged)="calculatorForm.ctrls.sortBy.setValue($event)"
          (toggleDescending)="calculatorForm.toggleSortDesc()"
          (filterRequested)="openFilter()"
        />

        @if (results.noResults()) {
          <div class="flex flex-col items-center text-center mt-8 gap-10">
            <img src="assets/images/no-results.svg" class="w-fit" alt="Kein Ergebnis" />
            <div>
              <div class="font-grotesk-h5">Ooops, keine Ergebnisse?</div>
              <div class="mt-6">
                Wir konnten leider keine Ergebnisse zu Deinen Vorgaben finden.<br />
                Gehe zurück und passe die berechnungsrelevanten Daten an.
              </div>
            </div>
          </div>
        } @else {
          <div>
            @for (item of tarifsToBeShown(); track item.kombinationId) {
              <ui-results-item-success
                [icon]="
                  (item.versichererBafinRegNr | map: results.findVersichererLogo$ | async) ??
                  undefined
                "
                [ergebnis]="item"
                [isBest]="item.kombinationId === bestTarifKombinationId()"
                [ungrouped]="showAllTarifsUngrouped()"
                [itemDetails]="itemDetails()"
                (selected)="tarifSelected.emit($event)"
              />
            }

            @for (placeholder of skeletons(); track placeholder) {
              <div class="w-full h-32 ghost shadow my-8 cp-shadow"></div>
            }
          </div>
        }

        @if (tarifsWithErrors().length) {
          <ui-divider class="my-6" />
          <div class="mt-6 flex flex-col gap-y-4">
            @for (item of tarifsWithErrors(); track item.kombinationId) {
              <ui-results-item-error
                [icon]="
                  (item.versichererBafinRegNr | map: results.findVersichererLogo$ | async) ??
                  undefined
                "
                [ergebnis]="item"
              />
            }
          </div>
        }
      </div>
    </div>

    @if (AppFunc.toggleRightSidebar$ | async) {
      <div class="fixed inset-0 z-50 flex bg-black bg-opacity-40" (click)="closeFilter()">
        <div
          class="ml-auto w-[344px] max-w-full h-full bg-white overflow-auto shadow-lg"
          (click)="$event.stopPropagation()"
        >
          <div class="flex items-center justify-between mb-2 border-b pt-4 ps-8 pe-3">
            <div class="text-xl font-bold">Filtern</div>
            <button mat-icon-button aria-label="Filter schließen" (click)="closeFilter()">
              <mat-icon svgIcon="cp-close-filled-normal" class="!w-8 !h-8" />
            </button>
          </div>
          <div class="p-4 pb-40 grid gap-y-8">
            <ng-container *ngTemplateOutlet="filterTemplate()" />
          </div>
        </div>
      </div>
    }
  }
</div>
